import { SearchFormType } from '../search-page-type.enum';
import { SearchParam, SearchParamType } from '../search-param.model';

export function executionUserFilterDefs(): SearchParam[] {
    return [
        {
            property: {
                name: 'surname',
                value: '',
            },
            layout: {
                row: 0,
                column: 0,
                autofocus: true,
                stretch: true,
            },
        },
        {
            property: {
                name: 'name',
                value: '',
            },
            layout: {
                row: 0,
                column: 1,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idProvenances',
                value: null,
            },
            layout: {
                row: 0,
                column: 2,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idRooms',
                value: null,
            },
            layout: {
                row: 0,
                column: 3,
                stretch: true,
            },
        },
        {
            property: {
                name: 'date',
                value: null,
            },
            layout: {
                row: 0,
                column: 4,
                stretch: true,
            },
        },
        {
            property: {
                name: 'patientId',
                value: '',
            },
            layout: {
                row: 1,
                column: 0,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idProvenanceGroups',
                value: null,
            },
            layout: {
                row: 1,
                column: 1,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idBusinessUnits',
                value: null,
            },
            layout: {
                row: 1,
                column: 2,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idAgendas',
                value: null,
            },
            layout: {
                row: 1,
                column: 3,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idEquipments',
                value: null,
            },
            layout: {
                row: 1,
                column: 4,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idModalities',
                value: null,
            },
            layout: {
                row: 1,
                column: 5,
                stretch: true,
            },
        },
        {
            property: {
                name: 'taxCode',
                value: '',
                defaultValue: '',
            },
            layout: {
                row: 1,
                column: 6,
                stretch: true,
            },
        },
        {
            property: {
                name: 'hospitalizationNumber',
                value: '',
                defaultValue: '',
            },
            layout: {
                row: 1,
                column: 7,
                stretch: true,
            },
        },
        {
            property: {
                name: 'braceletNumber',
                value: '',
                defaultValue: '',
            },
            layout: {
                row: 1,
                column: 8,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idReferringPhysicians',
                value: null,
            },
            layout: {
                row: 1,
                column: 9,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idPerformingPhysicians',
                value: null,
            },
            layout: {
                row: 1,
                column: 10,
                stretch: true,
            },
        },
        {
            property: {
                name: 'idTechnicians',
                value: null,
            },
            layout: {
                row: 1,
                column: 11,
                stretch: true,
            },
        },
        {
            property: {
                name: 'otherPatientId',
                value: null,
            },
            layout: {
                row: 1,
                column: 12,
                stretch: true,
            },
        },
        {
            property: {
                name: 'status',
                value: null,
            },
            layout: {
                row: 1,
                column: 13,
                stretch: true,
            },
        },
    ];
}

export function executionSiteFilterDefs(): SearchParam[] {
    return [
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'surname',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'LastName',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'name',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'FirstName',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idProvenances',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsProvenance',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    displayProperty: 'description',
                    refSearchParamPropertyNames: ['idProvenances'],
                    foreingKeys: ['IdProvenanceGroup'],
                },
            },
            labelTranslationKey: 'Provenance',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idRooms',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsRoom',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    displayProperty: 'description',
                },
            },
            labelTranslationKey: 'Room',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'date',
                type: SearchParamType.fromTo,
                value: null,
                defaultValue: {
                    from: '0#0#0',
                    to: '0#0#0',
                },
            },
            labelTranslationKey: {
                from: 'From',
                to: 'To',
                label: 'ExamDate',
            },
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'patientId',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'PatientId',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idProvenanceGroups',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsProvenanceGroup',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    displayProperty: 'description',
                },
            },
            labelTranslationKey: 'ProvenanceGroup',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idBusinessUnits',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsBusinessUnit',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    displayProperty: 'description',
                },
            },
            labelTranslationKey: 'BusinessUnit',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idAgendas',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsAgenda',
                    displayProperty: 'description',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    refSearchParamPropertyNames: ['IdEquipment'],
                    foreingKeys: ['IdEquipment'],
                },
            },
            labelTranslationKey: 'Agenda',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idEquipments',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsEquipment',
                    displayProperty: 'description',
                    enableTooltip: true,
                    refSearchParamPropertyNames: ['idBusinessUnits', 'idRoom'],
                    foreingKeys: ['IdBusinessUnits', 'IdRoom'],
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                },
            },
            labelTranslationKey: 'Equipment',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idModalities',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsModality',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                    displayProperty: 'description',
                },
            },
            labelTranslationKey: 'Modality',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'taxCode',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'TaxCode',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'hospitalizationNumber',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'HospitalizationNumber',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'braceletNumber',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'BraceletNumber',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idReferringPhysicians',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsReferringPhysician',
                    displayProperty: 'description',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                },
            },
            labelTranslationKey: 'ReferringPhysician',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idPerformingPhysicians',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsExecutor',
                    displayProperty: 'description',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                },
            },
            labelTranslationKey: 'PerformingPhysician',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'idTechnicians',
                type: SearchParamType.filterMultiSelect,
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsTechnician',
                    displayProperty: 'description',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                },
            },
            labelTranslationKey: 'Technician',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'otherPatientId',
                type: SearchParamType.string,
            },
            labelTranslationKey: 'OtherPatientId',
        },
        {
            active: true,
            clearOnBack: false,
            property: {
                name: 'status',
                type: SearchParamType.filterMultiSelect,
                defaultValue: ['c2003d48-f678-4d9c-849b-fd1deaef70df','9a7d577a-2cb4-4d3d-b304-96c512d7079d'],
                itemsSourceInfo: {
                    form: SearchFormType.EXECUTION,
                    controllerName: 'ListWorkFlow',
                    methodName: 'GetListItems?lsName=lsStatus',
                    displayProperty: 'description',
                    enableTooltip: true,
                    sortCollectionDataInfo: {
                        field: 'description',
                    },
                },
            },
            labelTranslationKey: 'Status',
        },
    ];
}
